import React from 'react'
import { Box } from 'pcln-design-system'
import { Modal } from 'pcln-modal'
import StyledHeading from '@/components/StyledHeading'
import useExpressDealModal from '@/hooks/useExpressDealModal'
import { ANALYTICS_CATEGORY_HOTELS } from '@/constants/analytics'
import CONTENT from '@/constants/content'
import { PromoDeal } from '../constants'
import { handleSubmitForExpressDeals } from '../SearchForm/utils'
import Form from '../SearchForm/Form'

export default function ExpressDealModal({
  isModalOpen,
  gaCategory = ANALYTICS_CATEGORY_HOTELS,
  qsKey = 'modal',
  qsValue = 'express-deals'
}: {
  isModalOpen: boolean
  gaCategory?: string
  qsKey?: string
  qsValue?: string
}) {
  const { closeModal } = useExpressDealModal(qsKey, qsValue)

  return (
    <Modal
      enableOverflow
      ariaLabel="Express Deals Search Modal"
      isOpen={isModalOpen}
      onClose={closeModal}
      timeout={50}
      width={[1, 750]}
    >
      <Box pt={4}>
        <StyledHeading
          fontSize={[3, null, null, 5]}
          lineHeight="display"
          tag="h1"
          text={CONTENT.homepage.hotel.expressDeals.headline}
        />
        <StyledHeading
          fontSize={[1, null, null, 4]}
          mb={3}
          lineHeight="display"
          tag="h2"
          text={CONTENT.homepage.hotel.expressDeals.subHeadline}
        />

        <Form
          onSubmit={values =>
            handleSubmitForExpressDeals({ ...values, gaCategory })
          }
          promoDeal={PromoDeal.EXPRESS_DEAL}
        />
      </Box>
    </Modal>
  )
}
